module.exports = __webpack_public_path__ + "img/FischspezialitätenMundt.b2ef5e6a.jpg";